import {
  DialogContent,
  DialogContentText,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
  makeStyles,
} from "@material-ui/core";
import {
  CheckboxWithLabel as FormikCheckboxWithLabel,
  Select as FormikSelect,
} from "formik-material-ui";

import CustomAlert from "../../../components/CustomAlert";
import DayJsUtils from "@date-io/dayjs";
import { Field } from "formik";
import { Autocomplete as FormikAutocomplete } from "formik-material-ui-lab";
import { KeyboardDatePicker as FormikKeyboardDatePicker } from "formik-material-ui-pickers";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import dayjs from "dayjs";
import { fetchApplicationKinds } from "../../../../services/applicationKindsService";
import { fetchApplicationStatus } from "../../../../services/applicationStatusService";
import { fetchMailTemplates } from "../../../../services/mailTemplatesService";
import localeEl from "dayjs/locale/el";
import localeEn from "dayjs/locale/en";
import useLocale from "../../../../hooks/useLocale";
import { useQuery } from "react-query";
import { useState } from "react";

const useStyles = makeStyles({
  dateContainer: {
    width: "100%",
  },
});

const CreateFlowApplicationStatusForm = ({
  setFieldValue,
  errors,
  touched,
  values,
}) => {
  const [error, setError] = useState("");
  const { t, locale } = useLocale();
  dayjs().locale(locale === "el-GR" ? localeEl : localeEn);
  const { data: applKinds } = useQuery(
    "applicationKinds",
    fetchApplicationKinds
  );
  const { data: applStatus } = useQuery(
    "applicationStatus",
    fetchApplicationStatus
  );
  const { data: mailTempl } = useQuery("mailTemplates", fetchMailTemplates);
  const classes = useStyles();

  return (
    <MuiPickersUtilsProvider
      locale={locale === "el-GR" ? localeEl : localeEn}
      utils={DayJsUtils}
    >
      <DialogContent>
        <DialogContentText>
          {t(
            "Fill in the form below and click on Add to add a new Flow Application Status"
          )}
        </DialogContentText>
      </DialogContent>
      <CustomAlert
        open={!!error}
        close={() => {
          setError("");
        }}
        message={t("A network error occured, please try again later")}
      />

      <DialogContent>
        <Field
          name="appl_kind"
          component={FormikAutocomplete}
          options={applKinds}
          getOptionLabel={(option) => option.dscr}
          renderInput={(params) => (
            <TextField
              required
              {...params}
              error={touched["appl_kind"] && !!errors["appl_kind"]}
              helperText={touched["appl_kind"] && errors["appl_kind"]}
              label={t("Application Kind")}
              variant="outlined"
              margin="normal"
            />
          )}
        />
        <Field
          name="from_sts"
          component={FormikAutocomplete}
          options={applStatus || []}
          getOptionLabel={(option) => option?.id + ". " + option?.dscr}
          renderInput={(params) => (
            <TextField
              required
              {...params}
              error={touched["from_sts"] && !!errors["from_sts"]}
              helperText={touched["from_sts"] && errors["from_sts"]}
              label={t("From Status")}
              variant="outlined"
              margin="normal"
            />
          )}
        />
        <Field
          name="to_sts"
          component={FormikAutocomplete}
          options={
            applStatus.filter((sts) => values?.from_sts?.id !== sts.id) || []
          }
          getOptionLabel={(option) => option?.id + ". " + option?.dscr}
          renderInput={(params) => (
            <TextField
              required
              {...params}
              error={touched["to_sts"] && !!errors["to_sts"]}
              helperText={touched["to_sts"] && errors["to_sts"]}
              label={t("To Status")}
              variant="outlined"
              margin="normal"
            />
          )}
        />
        <Field
          component={FormikCheckboxWithLabel}
          type="checkbox"
          name="reject_flg"
          onChange={(event, newValue) => {
            setFieldValue("reject_flg", newValue ? 1 : 0);
          }}
          Label={{ label: t("Rejection") }}
        />
        <Field
          component={FormikCheckboxWithLabel}
          type="checkbox"
          name="final_flg"
          onChange={(event, newValue) => {
            setFieldValue("final_flg", newValue ? 1 : 0);
          }}
          Label={{ label: t("Final Step") }}
        />
        <Field
          component={FormikCheckboxWithLabel}
          type="checkbox"
          name="mail_flg"
          onChange={(event, newValue) => {
            setFieldValue("mail_flg", newValue ? 1 : 0);
          }}
          Label={{ label: t("Mail") }}
        />
        <FormControl>
          <InputLabel htmlFor="validation">{t("Validation")}</InputLabel>
          <Field
            style={{ width: 250, alignSelf: "center" }}
            formHelperText={{ children: "How old are you?" }}
            component={FormikSelect}
            id="validation"
            name="validation"
            labelId="validation"
            label="Validation"
          >
            <MenuItem value={1}>{t("Documents check")}</MenuItem>
            <MenuItem value={2}>{t("Referrals check")}</MenuItem>
            <MenuItem value={3}>{t("None")}</MenuItem>
          </Field>
        </FormControl>
        <Field
          name="templ_mail"
          component={FormikAutocomplete}
          options={mailTempl}
          getOptionLabel={(option) => option.dscr}
          renderInput={(params) => (
            <TextField
              required
              {...params}
              error={touched["templ_mail"] && !!errors["templ_mail"]}
              helperText={touched["templ_mail"] && errors["templ_mail"]}
              label={t("Mail Template")}
              variant="outlined"
              margin="normal"
            />
          )}
        />
        <div className={classes.dateContainer}>
          <Field
            component={FormikKeyboardDatePicker}
            label={t("Effective Date")}
            format="DD/MM/YYYY"
            style={{ width: "45%", marginBottom: "20px" }}
            showTodayButton
            name="effective_date"
            todayLabel={t("Today")}
            cancelLabel={t("Cancel")}
            onChange={(date) => {
              setFieldValue("effective_date", dayjs(date).format("MM/DD/YYYY"));
            }}
          />
        </div>
        <div className={classes.dateContainer}>
          <Field
            component={FormikKeyboardDatePicker}
            label={t("Termination Date")}
            format="DD/MM/YYYY"
            style={{ width: "45%", marginBottom: "20px" }}
            name="termination_date"
            minDate={values.effective_date || dayjs()}
            todayLabel={t("Today")}
            cancelLabel={t("Cancel")}
            onChange={(date) => {
              setFieldValue(
                "termination_date",
                dayjs(date).format("MM/DD/YYYY")
              );
            }}
          />
        </div>
      </DialogContent>
    </MuiPickersUtilsProvider>
  );
};

export default CreateFlowApplicationStatusForm;
